import {Pipe, PipeTransform} from "@angular/core";
import {PAY_METHODS} from "../_maps/pay-methods";

@Pipe({name: "payMethod"})
export class PayMethodPipe implements PipeTransform {
  transform(method: string): any {
    return method && PAY_METHODS[method];
  }
}
